<template>
  <div id="grnhse_app"></div>
</template>

<script>
export default {
  data() {
    return {
      openRoles: undefined
    }
  },
  mounted() {
    const greenhouseDiv = document.getElementById('grnhse_app')
    const greenhouseIframe = document.createElement('script')
    greenhouseIframe.src = 'https://boards.greenhouse.io/embed/job_board/js?for=mikmak'
    greenhouseDiv.appendChild(greenhouseIframe)
  },
  methods: {
    makeShortDesc(desc) {
      desc = desc.split('<div>')[1]
      desc = desc.split('<br')[0]

      return desc.trim()
    }
  },
  computed: {
    careersContent() {
      return this.$store.state.careersContent
    }
  },
  watch: {}
}
</script>

<style scoped>

  .block-el {
    display: block;
    width: 75%;
    margin: 24px auto;
    color: #333;
  }

  @media only screen and (max-width: 800px) {
    .block-el {
      width: 85%;
      font-size: 20px;
    }
  }

  .page {
    padding: 24px;
  }
  p {
    font-size: 18px;
  }

  @media only screen and (max-width: 800px) {
    p {
      font-size: 20px;
    }
  }

  .open-positions {
    display: block;
  }

  .open-positions h1 {
    font-size: 24px;
    border-bottom: 1px solid;
    padding: 4px 0;
    color: rgba(0, 0, 0, 0.47);
  }

  .open-position {
    display: block;
    padding-top: 24px;
    background: #fff;
    padding: 12px;
    border-radius: 2px;
    margin-bottom: 24px;
    border: 1px solid #e0e0e0;
  }

  .open-position-title {
    display: block;
    text-transform: uppercase;
    font-size: 24px;
    color: #00BFBD;
    font-weight: bold;
  }

  .open-position-shortDesc {
    display: block;
    font-size: 18px;
    margin: 24px 0;
    color: rgba(0, 0, 0, 0.56);
  }

  .open-position-learn-more {
    display: inline-block;
    text-decoration: none;
    color: white;
    background: #00BFBD;
    font-size: 18px;
    padding: 2px 24px;
    border-radius: 4px;
  }

  .loading-roles {
    color: gray;
    text-align: center;
    background: #eaeaea;
    padding: 12px;
    font-size: 14px;
    border-radius: 2px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.14);
  }

  .loading-roles i {
    margin-left: 12px;
    font-size: 12px;
  }

  div#grnhse_app {
    background: white;
    max-width: 70%;
    margin: 0 auto;
    margin-top: -20px;
    margin-bottom: 48px;
    box-shadow: 0 0px 5px #eaeaea;
  }

  @media only screen and (max-width: 800px) {
    div#grnhse_app {
      width: 95%;
      max-width: 95%;
    }
  }

</style>



// WEBPACK FOOTER //
// CareersContent.vue?c6124f12